import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useViewStore = defineStore('view', () => {
  const viewType = ref<'large' | 'desktop' | 'mobile'>('desktop');

  const getViewType = computed(() => viewType);

  const setLarge = () => {
    viewType.value = 'large';
  };

  const setDesktop = () => {
    viewType.value = 'desktop';
  };

  const setMobile = () => {
    viewType.value = 'mobile';
  };

  return {
    viewType,
    getViewType,
    setLarge,
    setDesktop,
    setMobile
  };
});
